'use strict';

import moment from 'moment' ;

function DeletedColorDirective() {
    return {
        restrict: 'A',
        scope: {
            deletedAt: '<'
        },
        link: function(scope, element, attrs, controller) {
            scope.$watch('deletedAt', (newValue, oldValue) => {
                if (scope.deletedAt) {
                    element.addClass('deleted-color');
                }
            });
            if (scope.deletedAt) {
                element.addClass('deleted-color');
            }
        }
    };
}

export default DeletedColorDirective;
